<template>
  <div class="sidebar" :data="backgroundColor">

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <!-- <div class="logo"> -->
      <!-- <a href="http://afes.com.my/" class="simple-text logo-mini dhes-logo">
          <img :src="logo" alt="app-logo" />
        </a>
        <a href="http://afes.com.my/" class="simple-text logo-normal">{{ title_hehe }}</a>

        <a class="simple-text logo-normal">
          <img :src="logo" alt="app-logo" class="dhes-logo" />
        </a> -->
      <!-- </div> -->
       
      <div style="background-color: transparent; text-decoration: none; border: none; margin:20px; " class="logo">
        <a class="simple-text logo-normal">
          <img :src="logo" style="background-color: #F5F6FA; padding: 20px;" />
        </a>
      </div>

      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index"
              :link="subLink"></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>


    </div>
  </div>
</template>
<script>
import { Divider } from "element-ui";
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "Creative Tim",
      description: "Sidebar title"
    },
    shortTitle: {
      type: String,
      default: "CT",
      description: "Sidebar short title"
    },
    logo: {
      type: String,
      default: "img/alam-flora-logo.png",
      description: "Sidebar app logo"
    },
    backgroundColor: {
      type: String,
      default: "vue",
      validator: value => {
        let acceptedValues = [
          "",
          "vue",
          "blue",
          "green",
          "orange",
          "red",
          "primary"
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar background color (vue|blue|green|orange|red|primary)"
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item"
    }
  },
  components: {
    [Divider.name]: Divider
  },
  data() {
    return {
      title_hehe: "AFES"
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
.dhes-logo {
  margin: 0%;
}

@media (min-width: 992px) {

  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
